const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const fetchJson = async (path) => {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }
  return response.json();
};

export const fetchPractitioners = async () => {
  try {
    return await fetchJson('/api/practitioners');
  } catch (error) {
    console.error('Error fetching practitioners:', error);
    return [];
  }
};

export const fetchPractitionerById = async (id) => {
  try {
    return await fetchJson(`/api/practitioners/${encodeURIComponent(id)}`);
  } catch (error) {
    console.error('Error fetching practitioner:', error);
    return null;
  }
};

export const fetchReviewsForPractitioner = async (id) => {
  try {
    return await fetchJson(`/api/practitioners/${encodeURIComponent(id)}/reviews`);
  } catch (error) {
    console.error('Error fetching written reviews:', error);
    return [];
  }
};

export const fetchCompanyReviews = async () => {
  return fetchJson('/api/reviews');
};

export const submitReviewForPractitioner = async (id, review) => {
  const response = await fetch(`${API_BASE}/api/practitioners/${encodeURIComponent(id)}/reviews`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(review),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result.detail || 'Could not submit your review. Please try again.');
  }
  return result;
};

export const fetchVideoReviewsForPractitioner = async (id) => {
  try {
    return await fetchJson(`/api/practitioners/${encodeURIComponent(id)}/video-reviews`);
  } catch (error) {
    console.error('Error fetching video reviews:', error);
    return [];
  }
};

export const getServiceCategories = (practitioners) => {
  const categories = new Set(['All']);
  practitioners.forEach((practitioner) => {
    const values = practitioner['Service categories'] || [];
    (Array.isArray(values) ? values : []).forEach((category) => {
      if (category) categories.add(category.trim());
    });
  });
  return Array.from(categories).sort();
};

export const filterPractitionersByCategory = (practitioners, selectedCategory) => {
  if (selectedCategory === 'All') return practitioners;
  return practitioners.filter((practitioner) =>
    (practitioner['Service categories'] || []).includes(selectedCategory)
  );
};